/* Note: Both this file and variant-picker.js are used. Whenever changes have to be implemented, it has to be done twice. */

/* eslint-disable */

/* Main. Should update both variant-picker and gibbys-variant-picker */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();

      this.updateAvailability();
      this.addEventListener('change', this.handleVariantChange.bind(this));

    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      const selectedOptions = this.getSelectedOptions();
      this.variant = null;

      // Get selected variant data (if variant exists).
      this.variant = this.data.product.variants.find((v) =>
        v.options.every((val, index) => val === selectedOptions[index])
      );

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateBarcode();
      this.updateSpecs();
      this.updateBackInStockSignup();
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          product: this.data.product
        }
      }));
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.getSelectedOptions() };
      }

      const updateOptionAvailability = (optionEl, available, soldout) => {
        const el = optionEl;
        const text = soldout ? theme.strings.noStock : theme.strings.noVariant;
        el.classList.toggle('is-unavailable', !available);

        if (optionEl.classList.contains('custom-select__option')) {
          const em = el.querySelector('em');

          if (em) {
            em.hidden = available;
          }

          if (!available) {
            if (em) {
              em.textContent = text;
            } else {
              el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${text}</em>`;
            }
          }
        } else if (!available) {
          el.nextElementSibling.title = text;
        } else {
          el.nextElementSibling.removeAttribute('title');
        }
      };

      // Flag all options as unavailable
      this.querySelectorAll('.js-option').forEach((optionEl) => {
        updateOptionAvailability(optionEl, false, false);
      });

      // Flag selector options as available or sold out, depending on the variant availability
      this.optionSelectors.forEach((selector, selectorIndex) => {
        this.data.product.variants.forEach((variant) => {
          let matchCount = 0;

          variant.options.forEach((option, optionIndex) => {
            if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
              matchCount += 1;
            }
          });

          if (matchCount === currVariant.options.length - 1) {
            const options = selector.querySelectorAll('.js-option');
            const optionEl = Array.from(options).find((opt) => {
              if (selector.dataset.selectorType === 'dropdown') {
                return opt.firstElementChild.textContent === variant.options[selectorIndex];
              }
              return (
                opt.nextElementSibling.querySelector('.js-value').textContent ===
                variant.options[selectorIndex]
              );
            });

            if (optionEl) {
              updateOptionAvailability(optionEl, variant.available, !variant.available);
            }
          }
        });
      });
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const backorderProdNoteEl = this.backorder.querySelector('.backorder__product_note');
          // const prodTitleEl = this.section.parentElement.parentElement.parentElement.querySelector('.gibbys-pdt-page-product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;
          // const backorderSKU = this.specsection.querySelector('.gibbys_updated_new_SKU');
          
          // backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          // backorderProdEl.textContent = `${backorderSKU.textContent}`;
          // backorderProdEl.textContent = 'this.variant.sku';
          backorderProdEl.textContent = 'This product';

          if (typeof this.data.formatted[this.variant.id].varBackorderMsg !== 'undefined') {
            backorderProdNoteEl.textContent = this.data.formatted[this.variant.id].varBackorderMsg;
          } else {
            backorderProdNoteEl.textContent = 'is backorderable';
          }

          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');

      // Gibbys Added Line for Selecting Elements
      this.specsectionleft = this.specsectionleft || this.section.querySelector('.product-pdt-info-set-wrapper-desktop');
      this.specsection = this.specsection || this.section.querySelector('.product-info');
        
      if (!this.price) return;

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        // New Gibbys Added Line for Pdt Spec
        // const variantSpecsEl = this.specsectionleft.querySelector('.gibbys-specs-panel');
        // const variantSpecsMobEl = this.specsection.querySelector('.gibbys-specs-panel');
        
        // New Gibbys Added Line for SKU
        // const priceUpdatedNewSKUEl = this.specsection.querySelector('.gibbys_updated_new_SKU');

        // New Gibbys Added Line for Save Story and Affirm
        const priceSaveStoryWrapperEl = this.price.querySelector('.price__save_story_wrapper');
        const priceAffirmSeparatorEl = this.price.querySelector('.gibbys_price_middle_gp');
        const priceAffirmAmountEl = this.price.querySelector('.gibbys_price_right_gp');

        // New Gibbys Added Line for Sale End Time
        // const saleEndTimeWrapperEl = this.specsection.querySelector('.sale-end-time-wrapper');
        
        // New Gibbys Added Line for Product Extra Info
        // const freeShippingEl = this.specsection.querySelector('.extra-product-tag-free-shipping');
        // const openBoxEl = this.specsection.querySelector('.extra-product-tag-open-box');
        // const specialOrderEl = this.specsection.querySelector('.extra-product-tag-special-order');
        // const updatedNotesEl = this.specsection.querySelector('.extra-product-notes-custom');
        // const presetNotesEl = this.specsection.querySelector('.extra-product-notes-preset');
        // const defaultNotesEl = this.specsection.querySelector('.extra-product-notes-default');
        // const specialOffersEl = this.specsection.querySelector('.product-special-offers');



        // Update current price and original price if on sale.
        if (priceCurrentEl)
          priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price || '';
        
        if (priceWasEl)
          priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';

        if (typeof this.data.formatted[this.variant.id].saveStoryAmount !== 'undefined') {
          priceSaveStoryWrapperEl.innerHTML = '<p class="price__save_story">Save <span class="price__save_story_amount">' + this.data.formatted[this.variant.id].saveStoryAmount + '</span></p>';
        } else {
          priceSaveStoryWrapperEl.innerHTML = '';
        }
        

      
        // Gibbys Added Lines (below and the line above)
        // priceUpdatedNewSKUEl.innerHTML = this.data.formatted[this.variant.id].updatedNewSKU || '';
        // priceUpdatedNewBarcodeEl.innerHTML = this.data.formatted[this.variant.id].updatedNewBarcode || '';

        if (this.data.formatted[this.variant.id].unformattedPrice <= 1500000 && this.data.formatted[this.variant.id].unformattedPrice >= 30000) {
          priceAffirmSeparatorEl.innerHTML = '<div class="gibbys_price_middle_gp_separator"></div><div class="gibbys_price_middle_gp_or">or</div><div class="gibbys_price_middle_gp_separator"></div>'
          priceAffirmAmountEl.innerHTML = '<img class="gibbys_affirm_pdt_page_price_gp_logo" src="https://cdn.shopify.com/s/files/1/0780/5226/2162/files/affirm-logo-26pxh.png?v=1695328184" alt="Affirm Logo" width="65px" height="26px" loading="eager" alt="Affirm Logo"><p class="gibbys_affirm_msg_line1">Payment as low as</p><div class="gibbys_affirm_line2_wrapper"><span class="gibbys_affirm_amt h6">' + this.data.formatted[this.variant.id].updatedAffirmAmt + '</span><span class="gibbys_affirm_per_month h6">/mo</span><div class="gibbys_affirm_info_wrapper"><img src="https://cdn.shopify.com/s/files/1/0780/5226/2162/files/info-icon.svg?v=1695403186" class="gibbys_affirm_info_icon" width="16px" height="16px" loading="eager" alt="Info icon"><div class="gibbys_affirm_info_tooltip"><p class="gibbys_affirm_info_tooltip_text">This monthly payment does not include any applicable tax or interest</p></div></div></div>';
        } else {
          priceAffirmSeparatorEl.innerHTML = '';
          priceAffirmAmountEl.innerHTML = '';
        }
          

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available);
      }

      this.price.querySelector('.price__default').hidden = !this.variant;
      this.price.querySelector('.price__no-variant').hidden = this.variant;
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      this.specsection = this.specsection || this.section.querySelector('.product-info');
      const priceUpdatedNewSKUEl = this.specsection.querySelector('.gibbys_updated_new_SKU');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }


    // New Gibbys Added Function for UPC
    
    updateBarcode() {
      this.barcode = this.barcode || this.section.querySelector('.product-barcode__value');
      if (!this.barcode) return;

      this.specsection = this.specsection || this.section.querySelector('.product-info');
      
      const priceUpdatedSKUDividerEl = this.specsection.querySelector('.gibbys-product-sku-barcode-divider');
      const priceUpdatedNewBarcodeEl = this.specsection.querySelector('.gibbys_updated_new_barcode');
    
      if (typeof this.data.formatted[this.variant.id].updatedNewBarcode !== 'undefined') {
        priceUpdatedSKUDividerEl.style.display = "inline";
        priceUpdatedNewBarcodeEl.textContent = 'UPC: ' + this.data.formatted[this.variant.id].updatedNewBarcode;
      } else {
        priceUpdatedSKUDividerEl.style.display = "none";
        priceUpdatedNewBarcodeEl.textContent = '';
      }
    }

    // New Gibbys Added Function for updating details

    updateSpecs() {
      this.specsectionleft = this.specsectionleft || this.section.querySelector('.product-pdt-info-set-wrapper-desktop');
      this.specsection = this.specsection || this.section.querySelector('.product-info');

      if (this.variant) {

        // New Gibbys Added Line for Pdt Spec
        const variantSpecsEl = this.specsectionleft.querySelector('.gibbys-specs-panel');
        const variantSpecsMobEl = this.specsection.querySelector('.gibbys-specs-panel');

        // New Gibbys Added Line for Sale End Time
        // const saleEndTimeWrapperEl = this.specsection.querySelector('.sale-end-time-wrapper');
        
        // New Gibbys Added Line for Product Extra Info
        const freeShippingEl = this.specsection.querySelector('.extra-product-tag-free-shipping');
        const openBoxEl = this.specsection.querySelector('.extra-product-tag-open-box');
        const specialOrderEl = this.specsection.querySelector('.extra-product-tag-special-order');
        const updatedNotesEl = this.specsection.querySelector('.extra-product-notes-custom');
        const presetNotesEl = this.specsection.querySelector('.extra-product-notes-preset');
        const defaultNotesEl = this.specsection.querySelector('.extra-product-notes-default');
        const specialOffersEl = this.specsection.querySelector('.product-special-offers');    
          
        /*
        if (typeof this.data.formatted[this.variant.id].saleEndTime !== 'undefined') {
          saleEndTimeWrapperEl.innerHTML = '<h6 class="sale-end-time-text">Sale ends </h6><div class="sale-end-time-value-wrapper"><h6 class="sale-end-time-value">' + this.data.formatted[this.variant.id].saleEndTime + '</h6></div>';
        } else {
          saleEndTimeWrapperEl.innerHTML = '';
        }*/

        // Gibbys Added Lines for updating extra product info
        if (freeShippingEl !== null) {
          if (this.data.formatted[this.variant.id].updatedFreeShipping == 1) {
            freeShippingEl.innerHTML = '<p class="extra-product-tag-text"><img src="https://cdn.shopify.com/s/files/1/0780/5226/2162/files/pdt-tag-free-shipping-icon.svg?v=1695392579" class="extra-product-tag-image" width="24px" height="24px" alt="Free Shipping" loading="eager"><span class="extra-tag-free-shipping-span">Free Shipping</span><span class="extra-tag-separator"> | </span></p>';
          } else {
            freeShippingEl.innerHTML = '';
          }
        }

        if (openBoxEl !== null) {
          if (this.data.formatted[this.variant.id].updatedConditions == 'Open Box') {
            openBoxEl.innerHTML = '<p class="extra-product-tag-text"><img src="https://cdn.shopify.com/s/files/1/0780/5226/2162/files/pdt-tag-open-box-icon.svg?v=1695392579" class="extra-product-tag-image" width="24px" height="24px" alt="Open Box" loading="eager">Open Box Product<span class="extra-tag-separator"> | </span></p>';
          } else {
            openBoxEl.innerHTML = '';
          }
        }

        if (specialOrderEl !== null) {
          if (this.data.formatted[this.variant.id].updatedConditions == 'Special Order') {
            specialOrderEl.innerHTML = '<p class="extra-product-tag-text"><img src="https://cdn.shopify.com/s/files/1/0780/5226/2162/files/pdt-tag-special-order-icon.svg?v=1695392579" class="extra-product-tag-image" width="24px" height="24px" alt="Special Order" loading="eager">Special Order<span class="extra-tag-separator"> | </span></p>';
          } else {
            specialOrderEl.innerHTML = '';
          }
        }

        if (presetNotesEl !== null) {
          if (typeof this.data.formatted[this.variant.id].presetNotes !== 'undefined') {
            presetNotesEl.innerHTML = '<p class="extra-product-notes-preset>' + this.data.formatted[this.variant.id].presetNotes + '</p>';
          } else {
            presetNotesEl.innerHTML = '';
          }
        }

        if (updatedNotesEl !== null) {
          if (typeof this.data.formatted[this.variant.id].updatedNotes !== 'undefined') {
            updatedNotesEl.innerHTML = this.data.formatted[this.variant.id].updatedNotes;
          } else {
            updatedNotesEl.innerHTML = '';
          }
        }

        if (specialOffersEl !== null) {
          if (typeof this.data.formatted[this.variant.id].specialOffers !== 'undefined') {
            specialOffersEl.innerHTML = '<div class="product-special-offers-inner"><p class="product-see-all-offers">See All Offers:</p>' + this.data.formatted[this.variant.id].specialOffers + '</div>';
          } else {
            specialOffersEl.innerHTML = '';
          }
        }
        
        // Gibbys Added Line for updating specs

        if (variantSpecsEl !== null ) {
          if (typeof this.data.formatted[this.variant.id].variantSpecs !== 'undefined') {
            variantSpecsEl.innerHTML = this.data.formatted[this.variant.id].variantSpecs;
          } else {
            variantSpecsEl.innerHTML = "No specs provided yet.";
          }
        }

        if (variantSpecsMobEl !== null ) {
          if (typeof this.data.formatted[this.variant.id].variantSpecs !== 'undefined') {
            variantSpecsMobEl.innerHTML = this.data.formatted[this.variant.id].variantSpecs;
          } else {
            variantSpecsMobEl.innerHTML = "No specs provided yet.";
          }
        }

      }
    }

    /**
     * Updates the Back In Stock Signup
     */
    updateBackInStockSignup() {
      this.backInStockSignupDiv =
        this.backInStockSignupDiv || this.section.querySelector('#gb-bis-wrapper');
      if (!this.backInStockSignupDiv) return;

      this.backInStockSignupSKU = 
        this.backInStockSignupSKU || this.section.querySelector('#gb-bis-variant-sku');
      if (!this.backInStockSignupSKU) return;
      

      if (this.variant && this.variant.available == true) {
        this.backInStockSignupDiv.style.display = "none";
      } else {
        this.backInStockSignupDiv.style.display = "block";
        this.backInStockSignupSKU.value = this.variant.sku;
      }
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          selectedOptions.push(selector.querySelector('input:checked').value);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
